/* eslint-disable no-console */
import {Row, Col, Typography} from 'antd';
import React, {useState} from 'react';

import FullLogo from '../../assets/FullLogo.svg';
import GreenRightSideImg from '../../assets/GreenerEarth.png';
import QT66Img from '../../assets/qt66.png';

import FinalScreen from './components/finalScreen';
import OtpVerification from './components/OtpScreen';
import SignUpScreen from './components/SignUpScreen';
import {ISignupFormData} from './Utils/Interfaces';

const {Title} = Typography;

const SignupPage: React.FC = () => {
  const [formData, setFormData] = useState({
    businessName: '',
    businessWebsite: '',
    firstName: '',
    lastName: '',
    password: '',
    subscribe: false,
    accept: false,
    email: ''
  });
  const [step, setStep] = useState('initial');
  const onFinish = (values: ISignupFormData) => {
    setStep('otp');
    setFormData(values);
  };

  const handleOtpVerify = () => {
    setStep('finished');
  };

  const handleChangeEmail = () => {
    setStep('initial');
  };

  const renderFormStep = () => {
    switch (step) {
      case 'initial':
        return <SignUpScreen initialFromData={formData} onFinish={onFinish} />;
      case 'otp':
        return (
          <OtpVerification
            formData={formData}
            onVerify={handleOtpVerify}
            onChangeEmail={handleChangeEmail}
          />
        );
      case 'finished':
        return <FinalScreen></FinalScreen>;
      default:
        return null;
    }
  };

  return (
    <div className="signup-container">
      <Row className="signup-row" justify="center" align="middle">
        <Col className="form-col" xs={24} md={12} lg={12}>
          <div className="form-wrapper">
            <div className="form-header">
              <img src={FullLogo} alt="Bharat Carbon" className="logo" />
              <Title level={3}>
                {step === 'initial' ? 'Signup for Bharat Carbon' : ''}
              </Title>
            </div>
            {renderFormStep()}
          </div>
        </Col>

        <Col className="right-col" xs={0} md={12} lg={12}>
          <div className="quote-block">
            <img src={QT66Img} alt="quote" className="earth-image" />
            <Title
              level={1}
              style={{
                color: '#607455',
                fontWeight: '400',
                marginTop: 0,
                marginBottom: 50,
                fontSize: 33
              }}
            >
              Your path to a cleaner and <br /> greener world starts here!
            </Title>
            <img
              src={GreenRightSideImg}
              alt="Greener Earth"
              className="earth-image"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignupPage;
